/* eslint-disable import/prefer-default-export */
import { createContext } from 'react';

const DummyContext = createContext({});
export default DummyContext;
